import { Component } from "@angular/core";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { OrganisationHierarchyNavigationService } from "../../navigation/organisation-hierarchy-navigation.service";
import { PersonNavigationService } from "../../navigation/person-navigation.service";
import { TeamHierarchyNavigationService } from "../../navigation/team-hierarchy-navigation.service";

@Component({
    selector: "adapt-menu-tab-content",
    styleUrl: "./menu-tab-content.component.css",
    templateUrl: "./menu-tab-content.component.html",
    standalone: false,
})
export class MenuTabContentComponent extends BaseComponent {
    public readonly organisationHierarchyId = OrganisationHierarchyNavigationService.HierarchyId;
    public readonly personHierarchyId = PersonNavigationService.HierarchyId;
    public readonly teamHierarchyId = TeamHierarchyNavigationService.HierarchyId;

    public constructor() {
        super();
    }
}
